<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Group By" >
                                        <select class="form-control" size="large" v-model="inputGroupBy" @click.prevent="autoChange">
                                            <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div v-if="inputGroupBy == 'monthly'" class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="From"><br>
                                        <a-month-picker v-model="inputFrom" placeholder="Select month" style="width:100%" :format="monthFormat"/>
                                    </base-input>
                                </div>
        
                                <div class="col-md-7">
                                    <base-input alternative="" label="To"><br>
                                        <a-month-picker v-model="inputTo" placeholder="Select month" style="width:100%" :format="monthFormat"/>
                                    </base-input>
                                </div>
                            </div>
                            <div v-else class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="From"><br>
                                        <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM-DD-YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row" v-if="site_type == 'ho'">
                                <div class="col-md-7">
                                    <base-input label="Location">
                                        <a-cascader v-model="inputLocation" :options="locationOptions" @change="onLocationChange" placeholder="All Locations" style="width: 100%" changeOnSelect/>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Sort By" >
                                        <select class="form-control" size="large" v-model="inputSortBy" @click.prevent="sortChange">>
                                            <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                                <div class="col-md-2 mt-3 pt-3">
                                    <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                        {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                                    </button>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input type="number" min="0" v-if="inputSortBy == 'total_amount' || inputSortBy == 'qty'" placeholder="" label="Show Top" v-model="inputShowTop" />
                                    <base-input type="number" min="0" v-else placeholder="" label="Show Top" v-model="inputShowTop" disabled/>
                                </div>
                            </div>
        
                            <h4 class="ml-2 fw-bold">Display Options</h4>
                            <div class="row">
                               <div class="ml-4 d-flex flex-column">
                                     <base-checkbox class="mb-2" v-model="isShowDetail" :disabled="inputGroupBy == ''">
                                       Show Details
                                     </base-checkbox>
                                 
                                     <base-checkbox class="mb-2" v-model="isShowReferenceCode">
                                       Show Reference Code
                                     </base-checkbox>
                                 
                                     <base-checkbox class="mb-2" v-model="isShowSalesmanComm">
                                       Show Salesman Commission
                                     </base-checkbox>
                                </div>
                            </div>
        
                            <h4 class="ml-2 mt-2 fw-bold">Totals</h4>
                            <div class="row">
                                <div class="ml-4 d-flex flex-column">
                                    <base-checkbox class="mb-2" v-model="isShowTotalAmountWithoutTax">
                                        Show Total Amount w/o Tax
                                    </base-checkbox>

                                    <base-checkbox class="mb-2" v-model="isNetReturn">
                                        Net of Returns Sales
                                    </base-checkbox>
                                    
                                </div>
                            </div>

                            <h4 class="ml-2 mt-2 fw-bold">Other Options</h4>
                            <div class="row mb-4">
                                <div class="ml-4 d-flex flex-column">
                                    <base-checkbox class="mb-2" v-model="isSeparateSite">
                                        Separate per site
                                    </base-checkbox>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <button class="btn btn-sm" style="background-color: #394A5D; color: white;" @click.prevent="advanceFilter(true)">
                                        {{toggleLabel}}
                                    </button>
                                </div>
                            </div>
        
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReportBg">Generate Report in PDF</button> &nbsp; &nbsp;

                            <!-- Range > 1 calendar month: Excel/CSV generated in the background -->
                            <template v-if="isLongRange">
                                <button class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFileBackground('xlsx')"> Generate Excel </button> &nbsp; &nbsp;
                                <button class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFileBackground('csv')"> Generate CSV </button> &nbsp; &nbsp;
                            </template>

                            <!-- Range <= 1 calendar month: existing synchronous generation -->
                            <template v-else>
                                <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;

                                <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                    <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click="onCsvDownloaded"> Download CSV </button> &nbsp; &nbsp;
                                </vue-json-to-csv>
                                <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateExcel"> Download excel </button> &nbsp; &nbsp;
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
            <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="advancedFilterVisible">
                <advance-filter :parentParams="advancedFilterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
            </a-drawer>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'
    import reportUtils, { dissectReportFilters } from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import * as ExcelJS from "exceljs";
    import { saveAs } from "file-saver";

    import {
        mapState,
        mapActions
    } from 'vuex'
    import { getReportDescription } from '../../utilities';

    var component_x;

    export default {
        components: {
            AdvanceFilter,VueJsonToCsv
        },
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputGroupBy: '',
                groupOptions: [
                    {key: '', value: 'No Grouping'},
                    {key: 'supplier_id', value: 'Supplier'},
                    {key: 'supplier_type_id', value: 'Supplier Type, Supplier'},
                    {key: 'brand_id', value: 'Brand'},
                    {key: 'division_id', value: 'Division'},
                    {key: 'department_id', value: 'Department'},
                    {key: 'section_id', value: 'Section'},
                    {key: 'category_id', value: 'Category'},
                    {key: 'customer_id', value: 'Customer'},
                    {key: 'customer_type_id', value: 'Customer Type'},
                    {key: 'daily', value: 'Daily Sales'},
                    {key: 'monthly', value: 'Monthly Sales'},
                    {key: 'salesman_id', value: 'Salesman'},
                ],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputLocation: [],
                locationOptions: [],
                headerExcelInfo: "",
                isShowTotalAmountWithoutTax: false,
                isShowSalesmanComm: false,
                isNetReturn: false,

                inputSortBy: 'id',
                sortOptions: [
                    {key: 'id', value: 'Product Code'},
                    {key: 'barcode', value: 'Barcode'},
                    {key: 'name', value: 'Name or Description'},
                    {key: 'total_amount', value: 'Total Amount'},
                    {key: 'qty', value: 'Total Quantity'}
                ],
                currDate: moment().format("L_LT").split(":").join(";"),
                isSeparateSite: true,
                isShowDetail: true,
                isShowReferenceCode: false,
                inputFrom: moment().startOf('month'),
                inputTo: moment().endOf('month'),
                monthFormat: 'MM/YYYY',
                birSalesReports: [],
                toggleAdvanceFilter: false,
                toggleLabel: "Advanced Filter",
                advancedFilterParams: {},
                params: {},
                advancedFilterVisible: true,

                showSortInfo: 'asc',
                inputShowTop: 0,
                JsonData: [],
                accessRights:[],
                accessCostPriceRights:[],
                reportDescription: '',
                // Timeout (ms) for the synchronous CSV/XLSX report request.
                reportTimeoutMs: 120000
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            if(component_x.categoriesOptions.length == 0){
                var options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                component_x.updateCategoriesOptions(options)
            }

            this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]
            

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            this.reportDescription = await getReportDescription(this.currentProfile)
            this.accessRights = this.$attrs.access_rights || []
            this.accessCostPriceRights = this.$attrs.access_costprice_rights || []
        },
        computed: {
            ...mapState(['currentProfile', 'endPoint', 'categoriesOptions']),
            // True when the selected effective report range is greater than
            // 14 days. In that case Excel/CSV are generated in the background
            // instead of synchronously. Uses the same effective dates as the
            // report (buildFromToHeaders).
            isLongRange() {
                return true;
                // let from, to
                // if (this.inputGroupBy === 'monthly') {
                //     if (this.inputFrom == null || this.inputTo == null) return false
                //     from = moment(this.inputFrom).startOf('month')
                //     to = moment(this.inputTo).endOf('month')
                // } else {
                //     if (!this.inputDate || this.inputDate.length < 2) return false
                //     from = moment(this.inputDate[0])
                //     to = moment(this.inputDate[1])
                // }
                // if (!from.isValid() || !to.isValid()) return false
                // // Background when the selected range is greater than 14 days:
                // // i.e. when the end date reaches or passes the 14-day boundary
                // // from the start date.
                // return !to.isBefore(from.clone().add(14, 'days'))
            }
        },
        watch: {
            inputLocation: {
                handler: 'handleInputLocationChange',
                deep: true
            },
            // When any report-defining filter changes, discard previously
            // generated data so the "Generate Report" button reappears and the
            // user can regenerate with the new filters.
            inputSite: { handler: 'resetGeneratedReport', deep: true },
            inputGroupBy: 'resetGeneratedReport',
            inputDate: { handler: 'resetGeneratedReport', deep: true },
            inputSortBy: 'resetGeneratedReport',
            isSeparateSite: 'resetGeneratedReport',
            isShowDetail: 'resetGeneratedReport',
            isShowReferenceCode: 'resetGeneratedReport',
            isShowSalesmanComm: 'resetGeneratedReport',
            isShowTotalAmountWithoutTax: 'resetGeneratedReport',
            isNetReturn: 'resetGeneratedReport',
            params: { handler: 'resetGeneratedReport', deep: true }
        },
        methods: {
            ...mapActions(['updateCategoriesOptions']),
            moment,
            async onLocationChange(){
                this.siteOptions = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                this.inputSite = this.siteOptions.map( s => s.id);
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            autoChange(e){
                if(e.target.value == ''){
                    this.isShowDetail = true
                }
            },
            sortChange(e){
                if(e.target.value != 'total_amount' || e.target.value != 'qty'){
                    this.inputShowTop = 0
                }
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            async convertDecimal(num){
                let number = 0;
                if(Number.isInteger(num)){
                    number = num.toFixed(0)
                }else{
                    number = num.toFixed(4)
                }
                return await number
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            changeParams(params, actualParams, mode){
                this.params = params
                this.advancedFilterParams = actualParams

                if(mode == 'filter'){
                    this.advanceFilter(false);
                }
            },
            async handleInputLocationChange(newVal, oldVal) {
                if (!newVal || newVal.length === 0) {
                    var userId = secureStorage.getItem("userId");
                    var sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
                    this.siteOptions = sites;
                    this.sort(this.siteOptions);
                    this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)
                    let siteId = secureStorage.getItem("defaultSiteId");
                    this.inputSite = [siteId]
                }
            },
            generateReport: async function () {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": from_date,
                    "date_to": to_date,
                    "group": this.inputGroupBy,
                    "isShow": this.isShowDetail,
                    "isShowReferenceCode": this.isShowReferenceCode,
                    "isShowSalesmanComm": this.isShowSalesmanComm,
                    "isShowTotalAmountWithoutTax": this.isShowTotalAmountWithoutTax,
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                    "top": this.inputShowTop,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "advanced_filter": this.params,
                    "isNetReturn": this.isNetReturn
                }

                // check if item returns exist
                if (parameters["isNetReturn"]) {               
                    let check_returns = await HTTPRequest.getRequest(this.endPoint + 'item_returns?', {
                        "site_id": parameters["site_id"],
                            "date_from": parameters["date_from"],
                            "date_to": parameters["date_to"],
                            "isSeparate": true
                    })
                    if (check_returns.length < 1)
                        parameters["isNetReturn"] = false
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'item_sales?', parameters);
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                    this.spinning = false;
                    return
                }
                var siteSpecific = get_request;

                if(siteSpecific.length > 0){
                    let paperSize = 'legal'
                    let x_size = 612.5815
                    let y_size = 0

                    if(this.isShowReferenceCode && this.isShowTotalAmountWithoutTax){
                        y_size = 1200
                        paperSize = [x_size, y_size]
                    }else if(this.isShowReferenceCode || this.isShowTotalAmountWithoutTax){
                        y_size = 1083
                        paperSize = [x_size, y_size]
                    }

                    if(this.isShowSalesmanComm){
                        if(y_size == 0){
                            x_size = 612.5815
                            y_size = 1083
                        } else if (y_size == 1083){
                            y_size = 1200
                        } else {
                            x_size = x_size + 118
                            y_size = y_size + 118
                        }
                        paperSize = [x_size, y_size]
                    }

                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: paperSize });

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let headers = [];
                    let headers_tmp =[];
                    if(this.isShowDetail == true){
                        headers_tmp.push({content: '#', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Prod. Code', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Barcode', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Stock No.', styles: {halign: 'center', valign: 'center'}});

                        if (this.isShowReferenceCode){
                            headers_tmp.push({content: 'Ref. Code', styles: {halign: 'center', valign: 'center'}})
                        }
                        
                        headers_tmp.push(
                            {content: 'Description', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Landed Cost', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Selling Price', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Qty', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Unit Cost', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Total Cost', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Avg Cost', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Avg Price', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Gross Price', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Discount', styles: {halign: 'center', valign: 'center'}}
                        )

                        if(this.isShowSalesmanComm){
                            headers_tmp.push({content: 'Salesman\nCommission', styles: {halign: 'center', valign: 'top'}})
                        }

                        headers_tmp.push({content: 'Total Amount', styles: {halign: 'center', valign: 'center'}})

                        if(this.isShowTotalAmountWithoutTax){
                            headers_tmp.push({content: 'Total Amount w/o Tax', styles: {halign: 'center', valign: 'top'}})
                        }

                        headers.push(headers_tmp)
                       
                    } else {
                        headers = [
                            [
                                '',
                                {content: 'Qty', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Total Amount', styles: {halign: 'center', valign: 'center'}}
                            ]
                        ]
                    }

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let total_qty = 0
                        let total_cost = 0
                        let total_amount = 0
                        let total_salesman_comm = 0
                        let total_amount_without_tax = 0
                        let total_gross_price = 0
                        let grand_qty = 0
                        let grand_total_cost = 0
                        let grand_total_amount = 0
                        let grand_total_amount_without_tax = 0
                        let grand_salesman_comm = 0
                        let grand_gross_price = 0
                        let grand_discount = 0;


                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];
                        let grouper = 'start'
                        let type_header = 'start'

                        if(this.birSalesReports.length > 0){
                            let monthly_grouper_arr = []
                            let arr = 'start'

                            if(this.inputGroupBy == 'monthly' && this.isShowDetail == true){
                                for(let i=0; i < this.birSalesReports.length; i++){
                                    let reportLine = this.birSalesReports[i]

                                    if(i == this.birSalesReports.length-1){
                                        if(arr == 'start'){
                                            monthly_grouper_arr.push({
                                                key: reportLine.grouper_id,
                                                value: reportLine.grouper_name
                                            });
                                        } else {
                                            if(arr.key == reportLine.grouper_id){

                                                //replace value then push
                                                if(arr.value > reportLine.grouper_name){
                                                    arr.value = reportLine.grouper_name
                                                }

                                                monthly_grouper_arr.push(arr)
                                            } else {
                                                //push prev arr
                                                monthly_grouper_arr.push(arr)

                                                //push current arr
                                                monthly_grouper_arr.push({
                                                    key: reportLine.grouper_id,
                                                    value: reportLine.grouper_name
                                                });
                                            }
                                        }
                                    } else {
                                        if(arr == 'start'){
                                            arr = {
                                                key: reportLine.grouper_id,
                                                value: reportLine.grouper_name
                                            }
                                        } else {
                                            if(arr.key == reportLine.grouper_id){
                                                //replace value
                                                if(arr.value > reportLine.grouper_name){
                                                    arr.value = reportLine.grouper_name
                                                }

                                            } else {
                                                //push prev arr
                                                monthly_grouper_arr.push(arr)

                                                //replace current arr
                                                arr = {
                                                    key: reportLine.grouper_id,
                                                    value: reportLine.grouper_name
                                                };
                                            }
                                        }
                                    }
                                }
                            }

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                let grouper_name = reportLine.grouper_name
                                if(this.inputGroupBy == 'daily'){
                                    grouper_name = moment(reportLine.grouper_name).format('YYYY/MM/DD')
                                } else if(this.inputGroupBy == 'monthly' && this.isShowDetail == true){
                                    let vdate = monthly_grouper_arr.find(x => x.key === reportLine.grouper_id).value
                                    grouper_name = moment(vdate).format('(YYYY) DD - MMMM')
                                } else if(this.inputGroupBy == 'monthly' && this.isShowDetail == false){
                                    grouper_name = moment(reportLine.grouper_name).format('(YYYY) DD - MMMM')
                                }

                                if(this.inputGroupBy == 'supplier_type_id'){
                                    if(type_header == 'start'){
                                        let type_header = [{content: reportLine.header_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}]
                                        reportData.push(Object.assign({}, type_header))
                                    } else {
                                        if(type_header != reportLine.header_id){
                                            let type_header = [{content: reportLine.header_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}]
                                            reportData.push(Object.assign({}, type_header))
                                        }
                                    }
                                    type_header = reportLine.header_id
                                }

                                if(this.inputGroupBy != ''){
                                    if(this.isShowDetail == true){
                                        if(grouper == 'start'){
                                            let detail_header = [{content: grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                            reportData.push(Object.assign({}, detail_header))
                                        } else {
                                            if(grouper != reportLine.grouper_id){
                                                let detail_header = [{content: grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                                reportData.push(Object.assign({}, detail_header))
                                            }
                                        }
                                        grouper = reportLine.grouper_id
                                    }
                                }

                                let detail = []
                                let qty = await this.convertDecimal(Number(reportLine.qty)) 

                                if(this.isShowDetail == true){
                                    detail = [
                                        i+1,
                                        reportLine.product_code,
                                        reportLine.barcode,
                                        reportLine.stock_no];
                                    
                                    if (this.isShowReferenceCode)
                                        detail.push(reportLine.reference_code)
                                    
                                    
                                    detail.push(
                                        {content: reportLine.description, styles: {halign: 'left'}},
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.landed_cost)), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.selling_price)), 'Y'),
                                        this.convertToCurrency(Number(reportLine.qty)),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.unit_cost)), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.total_cost)), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.avg_cost)), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.avg_price)), 'Y'),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.gross_price)), 'Y'),
                                        this.convertToCurrency(Number(reportLine.discount))
                                    );
                                    
                                    if(this.isShowSalesmanComm){
                                        detail.push(reportLine.salesman_commission)
                                    }

                                    // Total Amount is a price-derived figure; mask with the View Price right 'Y'.
                                    detail.push(this.addMaskValidation(reportLine.total_amount, 'Y'))
                                    
                                    if(this.isShowTotalAmountWithoutTax){
                                        detail.push(this.addMaskValidation(reportLine.total_amount_without_tax, 'Y'))
                                    }
                                } else {
                                    detail = [
                                        grouper_name,
                                        qty,
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.total_amount)), 'Y')
                                    ]
                                }

                                reportData.push(Object.assign({}, detail))

                                if(this.isShowSalesmanComm){
                                    total_salesman_comm += Number(reportLine.salesman_commission)
                                    grand_salesman_comm += Number(reportLine.salesman_commission)
                                }
                                total_amount += Number(reportLine.total_amount)
                                grand_total_amount += Number(reportLine.total_amount)

                                if(this.isShowTotalAmountWithoutTax){
                                    total_amount_without_tax += Number(reportLine.total_amount_without_tax)
                                    grand_total_amount_without_tax += Number(reportLine.total_amount_without_tax)
                                }
                                total_qty += Number(reportLine.qty)
                                total_cost += Number(reportLine.total_cost)
                                total_gross_price += Number(reportLine.gross_price)

                                grand_qty += Number(reportLine.qty)
                                grand_total_cost += Number(reportLine.total_cost)
                                grand_gross_price += Number(reportLine.gross_price)
                                grand_discount += Number(reportLine.discount);

                                if(i == this.birSalesReports.length-1){
                                    if(this.inputGroupBy != ''){
                                        let sub_detail = []
                                        if(this.isShowDetail == true){
                                            let spacer = grouper_name
                                            if(this.inputGroupBy == 'supplier_type_id'){
                                                spacer = reportLine.header_name
                                            }

                                            sub_detail = ["", "", "", "",
                                                {content: spacer, styles: {halign: 'right', fontStyle: 'bold'}}, "",
                                                this.convertToCurrency(total_qty), '',this.addMaskValidation(this.convertToCurrency(total_cost), 'Z'), '', '',this.addMaskValidation(this.convertToCurrency(total_gross_price), 'Y') , this.convertToCurrency(grand_discount)
                                            ]

                                            if ((this.inputGroupBy == 'monthly' || this.inputGroupBy == 'supplier_id' || this.inputGroupBy == 'supplier_type_id') && this.isShowDetail == true) {
                                                let spacerIndex = sub_detail.findIndex(item => typeof item === 'object' && item.content === spacer);
                                                if(this.isShowReferenceCode){
                                                    sub_detail.splice(spacerIndex + 1, 0,"");
                                                    sub_detail.splice(spacerIndex - 1, 0,"")
                                                } else {
                                                    sub_detail.splice(spacerIndex + 1, 0, "");
                                                }
                                            }

                                            if(this.isShowSalesmanComm){
                                                sub_detail.push(this.convertToCurrency(total_salesman_comm))
                                            }

                                            sub_detail.push(this.addMaskValidation(this.convertToCurrency(total_amount), 'Y'))

                                            if(this.isShowTotalAmountWithoutTax){
                                                sub_detail.push(this.addMaskValidation(this.convertToCurrency(total_amount_without_tax), 'Y'))
                                            }

                                            reportData.push(Object.assign({}, ["rowLine"]))
                                            reportData.push(Object.assign({}, sub_detail))
                                        }
                                    }

                                    reportData.push(Object.assign({}, ["rowLine"]))

                                    if(this.isShowDetail == true){
                                        let detail_arr = ['','', '', '']
                                        
                                        if(this.isShowReferenceCode){
                                            detail_arr.push('');
                                        }

                                        detail_arr.push('Grand Total :', '','',
                                            this.convertToCurrency(grand_qty), '',this.addMaskValidation(this.convertToCurrency(grand_total_cost), 'Z'), '', '',this.addMaskValidation(this.convertToCurrency(grand_gross_price), 'Y'),  this.convertToCurrency(grand_discount) 
                                        );

                                        if(this.isShowSalesmanComm){
                                            detail_arr.push(this.convertToCurrency(grand_salesman_comm))
                                        }

                                        detail_arr.push(this.addMaskValidation(this.convertToCurrency(grand_total_amount), 'Y'))

                                        if(this.isShowTotalAmountWithoutTax){
                                            detail_arr.push(this.addMaskValidation(this.convertToCurrency(grand_total_amount_without_tax), 'Y'))
                                        }
                                        
                                        reportData.push(Object.assign({}, detail_arr));
                                    } else {
                                        reportData.push(Object.assign({}, ['Grand Total :',
                                            await this.convertDecimal(Number(grand_qty)),
                                            this.addMaskValidation(this.convertToCurrency(grand_total_amount), 'Y')
                                        ]));
                                    }
                                } else {
                                    if(this.isShowDetail == true){
                                        let current_grouper = ""
                                        let next_grouper = ""
                                        if(this.inputGroupBy == 'supplier_type_id'){
                                            current_grouper = reportLine.header_id
                                            next_grouper = this.birSalesReports[i+1].header_id
                                        } else {
                                            current_grouper = reportLine.grouper_id
                                            next_grouper = this.birSalesReports[i+1].grouper_id
                                        }

                                        if(current_grouper != next_grouper){
                                            if(this.inputGroupBy != ''){
                                                reportData.push(Object.assign({}, ["rowLine"]))
                                                let sub_detail = []

                                                let spacer = grouper_name
                                                if(this.inputGroupBy == 'supplier_type_id'){
                                                    spacer = reportLine.header_name
                                                }

                                                if(this.isShowDetail == true){
                                                    sub_detail = ["", "", "", ""]
                                        
                                                    if(this.isShowReferenceCode){
                                                        sub_detail.push('');
                                                    }

                                                    sub_detail.push({content: spacer, styles: {halign: 'right', fontStyle: 'bold'}}, "",'',
                                                        await this.convertDecimal(Number(total_qty)), '',this.addMaskValidation(this.convertToCurrency(total_cost), 'Z'), '', '', this.addMaskValidation(this.convertToCurrency(total_gross_price), 'Y'),""
                                                    );

                                                    if(this.isShowSalesmanComm){
                                                        sub_detail.push(this.convertToCurrency(total_salesman_comm))
                                                    }

                                                    sub_detail.push(this.addMaskValidation(this.convertToCurrency(total_amount), 'Y'))

                                                    if(this.isShowTotalAmountWithoutTax){
                                                        sub_detail.push(this.addMaskValidation(this.convertToCurrency(total_amount_without_tax), 'Y'))
                                                    }
                                                } else {
                                                    sub_detail = [{content: spacer, styles: {halign: 'right', fontStyle: 'bold'}},
                                                        await this.convertDecimal(Number(total_qty)),
                                                        this.addMaskValidation(this.convertToCurrency(total_amount), 'Y')
                                                    ]
                                                }
                                                reportData.push(Object.assign({}, sub_detail))

                                                total_qty = 0
                                                total_amount = 0
                                                total_gross_price = 0
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                        }

                        let design_x = 525
                        let design_y = 225
                        
                        if(this.isShowDetail == true){
                            design_x = 600
                            design_y = 400
                        }
                        
                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"Item Sales Report" + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        if(this.isSeparateSite == true){
                            doc.text(15, 35, "Site: " + siteSpecific[x].report_details[0].site_name, "left");
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            doc.text(15, 35, "Site/s: " + site_text, "left");
                        }
                        doc.text(15,25,"For the Period of " + from_header + " to " + to_header)
                        let filterText = dissectReportFilters(parameters, this.displayOptions, this.formatOptions)
                        const {basic, advance} = filterText
                        let splitTitle;
                        if (Object.keys(parameters.advanced_filter).length !== 0) {
                            if (advance.trim().length !== 0) {
                                splitTitle = "Filtered by: " + status_header + "," + advance;
                            } else {
                                splitTitle = "Filtered by: " + status_header + filter_header;
                            }
                        } else {
                            splitTitle = "Filtered by: " + status_header + filter_header;
                        }
                        splitTitle = doc.splitTextToSize(splitTitle, 250);


                        doc.text(15,30,splitTitle);

                        let colStyles = {}
                        
                        if(this.isShowDetail == true){
                            if(this.isShowReferenceCode && this.isShowTotalAmountWithoutTax){
                                colStyles = {
                                    0: {cellWidth: 10},
                                    1: {cellWidth: 25},
                                    2: {cellWidth: 27},
                                    3: {cellWidth: 22},
                                    4: {cellWidth: 27},
                                    5: {cellWidth: 50},
                                    6: {cellWidth: 19},
                                    7: {cellWidth: 22},
                                    8: {cellWidth: 19},
                                    9: {cellWidth: 19},
                                    10: {cellWidth: 22},
                                    11: {cellWidth: 19},
                                    12: {cellWidth: 22},
                                    13: {cellWidth: 22},
                                    14: {cellWidth: 19},
                                    15: {cellWidth: 22},
                                    16: {cellWidth: 22},
                                }
                            } else if (this.isShowReferenceCode){
                                colStyles = {
                                    0: {cellWidth: 10},
                                    1: {cellWidth: 25},
                                    2: {cellWidth: 27},
                                    3: {cellWidth: 22},
                                    4: {cellWidth: 22},
                                    5: {cellWidth: 50},
                                    6: {cellWidth: 19},
                                    7: {cellWidth: 22},
                                    8: {cellWidth: 19},
                                    9: {cellWidth: 19},
                                    10: {cellWidth: 19},
                                    11: {cellWidth: 19},
                                    12: {cellWidth: 22},
                                    13: {cellWidth: 22},
                                    14: {cellWidth: 19},
                                    15: {cellWidth: 22},
                                }
                            } else if (this.isShowTotalAmountWithoutTax){
                                colStyles = {
                                    0: {cellWidth: 10},
                                    1: {cellWidth: 25},
                                    2: {cellWidth: 27},
                                    3: {cellWidth: 22},
                                    4: {cellWidth: 50},
                                    5: {cellWidth: 19},
                                    6: {cellWidth: 22},
                                    7: {cellWidth: 19},
                                    8: {cellWidth: 19},
                                    9: {cellWidth: 19},
                                    10: {cellWidth: 22},
                                    11: {cellWidth: 22},
                                    12: {cellWidth: 22},
                                    13: {cellWidth: 19},
                                    14: {cellWidth: 22},
                                    15: {cellWidth: 22},
                                }
                            } else {
                                colStyles = {
                                    0: {cellWidth: 10},
                                    1: {cellWidth: 25},
                                    2: {cellWidth: 27},
                                    3: {cellWidth: 22},
                                    4: {cellWidth: 50},
                                    5: {cellWidth: 19},
                                    6: {cellWidth: 22},
                                    7: {cellWidth: 19},
                                    8: {cellWidth: 19},
                                    9: {cellWidth: 19},
                                    10: {cellWidth: 19},
                                    11: {cellWidth: 19},
                                    12: {cellWidth: 20},
                                    13: {cellWidth: 19},
                                    14: {cellWidth: 22},
                                    15: {cellWidth: 20},
                                }
                            }
                            
                        } else {
                            colStyles = {
                                0: {cellWidth: 205},
                                1: {cellWidth: 60},
                                2: {cellWidth: 60}
                            }
                        }

                        doc.autoTable({
                            startY: 45,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2,
                                rowHeight: 18
                            },
                            margin: { bottom: 30 },
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right',
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && (data.row.raw[0] == 'Grand Total :' || data.row.raw[3] == 'Grand Total :')){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        let pageCount = doc.internal.getNumberOfPages();

                        for(let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            reportUtils.pdfTools.addFooter(doc, printed_by, "Item Sales Report" + group_text, design_x, design_y, i, pageCount)
                        }
                    }
                    doc.save(`Item_Sales_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x,'warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning = false;
            },
            generateReportBg: async function () {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": from_date,
                    "date_to": to_date,
                    "group": this.inputGroupBy,
                    "isShow": this.isShowDetail,
                    "isShowReferenceCode": this.isShowReferenceCode,
                    "isShowSalesmanComm": this.isShowSalesmanComm,
                    "isShowTotalAmountWithoutTax": this.isShowTotalAmountWithoutTax,
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                    "top": this.inputShowTop,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "advanced_filter": this.params,
                    "isNetReturn": this.isNetReturn
                }

                // check if item returns exist
                if (parameters["isNetReturn"]) {               
                    let check_returns = await HTTPRequest.getRequestReport(this.endPoint + 'item_returns?', {
                        "site_id": parameters["site_id"],
                            "date_from": parameters["date_from"],
                            "date_to": parameters["date_to"],
                            "isSeparate": true
                    })
                    if (check_returns.length < 1)
                        parameters["isNetReturn"] = false
                }

                var get_request = await HTTPRequest.getRequestReport(this.endPoint + 'item_sales_background?', parameters);
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                    this.spinning = false;
                    return
                }else{
                    console.log("No error")
                    this.$notification['success']({
                        message: 'Report Generating',
                        description: "Report running in background. Check jobs page to monitor report generation.",
                        style:{
                            color: 'rgba(0, 0, 0, 0.65)',
                            border: '1px solid #b7eb8f',
                            backgroundColor: '#f6ffed'
                        }
                    });
                }

                // var siteSpecific = get_request;

                // if(siteSpecific.length > 0){
                //     let paperSize = 'legal'
                //     let x_size = 612.5815
                //     let y_size = 0

                //     if(this.isShowReferenceCode && this.isShowTotalAmountWithoutTax){
                //         y_size = 1200
                //         paperSize = [x_size, y_size]
                //     }else if(this.isShowReferenceCode || this.isShowTotalAmountWithoutTax){
                //         y_size = 1083
                //         paperSize = [x_size, y_size]
                //     }

                //     if(this.isShowSalesmanComm){
                //         if(y_size == 0){
                //             x_size = 612.5815
                //             y_size = 1083
                //         } else if (y_size == 1083){
                //             y_size = 1200
                //         } else {
                //             x_size = x_size + 118
                //             y_size = y_size + 118
                //         }
                //         paperSize = [x_size, y_size]
                //     }

                //     var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: paperSize });

                //     let reportLogo = document.getElementById('reportLogo');
                //     doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                //     let headers = [];
                //     let headers_tmp =[];
                //     if(this.isShowDetail == true){
                //         headers_tmp.push({content: '#', styles: {halign: 'center', valign: 'center'}},
                //                 {content: 'Prod. Code', styles: {halign: 'center', valign: 'center'}},
                //                 {content: 'Barcode', styles: {halign: 'center', valign: 'center'}},
                //                 {content: 'Stock No.', styles: {halign: 'center', valign: 'center'}});

                //         if (this.isShowReferenceCode){
                //             headers_tmp.push({content: 'Ref. Code', styles: {halign: 'center', valign: 'center'}})
                //         }
                        
                //         headers_tmp.push(
                //             {content: 'Description', styles: {halign: 'center', valign: 'center'}},
                //             {content: 'Landed Cost', styles: {halign: 'center', valign: 'center'}},
                //             {content: 'Selling Price', styles: {halign: 'center', valign: 'center'}},
                //             {content: 'Qty', styles: {halign: 'center', valign: 'center'}},
                //             {content: 'Unit Cost', styles: {halign: 'center', valign: 'center'}},
                //             {content: 'Total Cost', styles: {halign: 'center', valign: 'center'}},
                //             {content: 'Avg Cost', styles: {halign: 'center', valign: 'center'}},
                //             {content: 'Avg Price', styles: {halign: 'center', valign: 'center'}},
                //             {content: 'Gross Price', styles: {halign: 'center', valign: 'center'}},
                //             {content: 'Discount', styles: {halign: 'center', valign: 'center'}}
                //         )

                //         if(this.isShowSalesmanComm){
                //             headers_tmp.push({content: 'Salesman\nCommission', styles: {halign: 'center', valign: 'top'}})
                //         }

                //         headers_tmp.push({content: 'Total Amount', styles: {halign: 'center', valign: 'center'}})

                //         if(this.isShowTotalAmountWithoutTax){
                //             headers_tmp.push({content: 'Total Amount w/o Tax', styles: {halign: 'center', valign: 'top'}})
                //         }

                //         headers.push(headers_tmp)
                       
                //     } else {
                //         headers = [
                //             [
                //                 '',
                //                 {content: 'Qty', styles: {halign: 'center', valign: 'center'}},
                //                 {content: 'Total Amount', styles: {halign: 'center', valign: 'center'}}
                //             ]
                //         ]
                //     }

                //     for(let x=0; x < siteSpecific.length; x++){
                //         this.birSalesReports = siteSpecific[x].report_details

                //         let total_qty = 0
                //         let total_cost = 0
                //         let total_amount = 0
                //         let total_salesman_comm = 0
                //         let total_amount_without_tax = 0
                //         let total_gross_price = 0
                //         let grand_qty = 0
                //         let grand_total_cost = 0
                //         let grand_total_amount = 0
                //         let grand_total_amount_without_tax = 0
                //         let grand_salesman_comm = 0
                //         let grand_gross_price = 0
                //         let grand_discount = 0;


                //         if(x > 0 && this.birSalesReports.length > 0){
                //             doc.addPage();
                //         }

                //         let reportData = [];
                //         let grouper = 'start'
                //         let type_header = 'start'

                //         if(this.birSalesReports.length > 0){
                //             let monthly_grouper_arr = []
                //             let arr = 'start'

                //             if(this.inputGroupBy == 'monthly' && this.isShowDetail == true){
                //                 for(let i=0; i < this.birSalesReports.length; i++){
                //                     let reportLine = this.birSalesReports[i]

                //                     if(i == this.birSalesReports.length-1){
                //                         if(arr == 'start'){
                //                             monthly_grouper_arr.push({
                //                                 key: reportLine.grouper_id,
                //                                 value: reportLine.grouper_name
                //                             });
                //                         } else {
                //                             if(arr.key == reportLine.grouper_id){

                //                                 //replace value then push
                //                                 if(arr.value > reportLine.grouper_name){
                //                                     arr.value = reportLine.grouper_name
                //                                 }

                //                                 monthly_grouper_arr.push(arr)
                //                             } else {
                //                                 //push prev arr
                //                                 monthly_grouper_arr.push(arr)

                //                                 //push current arr
                //                                 monthly_grouper_arr.push({
                //                                     key: reportLine.grouper_id,
                //                                     value: reportLine.grouper_name
                //                                 });
                //                             }
                //                         }
                //                     } else {
                //                         if(arr == 'start'){
                //                             arr = {
                //                                 key: reportLine.grouper_id,
                //                                 value: reportLine.grouper_name
                //                             }
                //                         } else {
                //                             if(arr.key == reportLine.grouper_id){
                //                                 //replace value
                //                                 if(arr.value > reportLine.grouper_name){
                //                                     arr.value = reportLine.grouper_name
                //                                 }

                //                             } else {
                //                                 //push prev arr
                //                                 monthly_grouper_arr.push(arr)

                //                                 //replace current arr
                //                                 arr = {
                //                                     key: reportLine.grouper_id,
                //                                     value: reportLine.grouper_name
                //                                 };
                //                             }
                //                         }
                //                     }
                //                 }
                //             }

                //             for(let i=0; i < this.birSalesReports.length; i++){
                //                 let reportLine = this.birSalesReports[i]

                //                 let grouper_name = reportLine.grouper_name
                //                 if(this.inputGroupBy == 'daily'){
                //                     grouper_name = moment(reportLine.grouper_name).format('YYYY/MM/DD')
                //                 } else if(this.inputGroupBy == 'monthly' && this.isShowDetail == true){
                //                     let vdate = monthly_grouper_arr.find(x => x.key === reportLine.grouper_id).value
                //                     grouper_name = moment(vdate).format('(YYYY) DD - MMMM')
                //                 } else if(this.inputGroupBy == 'monthly' && this.isShowDetail == false){
                //                     grouper_name = moment(reportLine.grouper_name).format('(YYYY) DD - MMMM')
                //                 }

                //                 if(this.inputGroupBy == 'supplier_type_id'){
                //                     if(type_header == 'start'){
                //                         let type_header = [{content: reportLine.header_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}]
                //                         reportData.push(Object.assign({}, type_header))
                //                     } else {
                //                         if(type_header != reportLine.header_id){
                //                             let type_header = [{content: reportLine.header_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}]
                //                             reportData.push(Object.assign({}, type_header))
                //                         }
                //                     }
                //                     type_header = reportLine.header_id
                //                 }

                //                 if(this.inputGroupBy != ''){
                //                     if(this.isShowDetail == true){
                //                         if(grouper == 'start'){
                //                             let detail_header = [{content: grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                //                             reportData.push(Object.assign({}, detail_header))
                //                         } else {
                //                             if(grouper != reportLine.grouper_id){
                //                                 let detail_header = [{content: grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                //                                 reportData.push(Object.assign({}, detail_header))
                //                             }
                //                         }
                //                         grouper = reportLine.grouper_id
                //                     }
                //                 }

                //                 let detail = []
                //                 let qty = await this.convertDecimal(Number(reportLine.qty)) 

                //                 if(this.isShowDetail == true){
                //                     detail = [
                //                         i+1,
                //                         reportLine.product_code,
                //                         reportLine.barcode,
                //                         reportLine.stock_no];
                                    
                //                     if (this.isShowReferenceCode)
                //                         detail.push(reportLine.reference_code)
                                    
                                    
                //                     detail.push(
                //                         {content: reportLine.description, styles: {halign: 'left'}},
                //                         this.addMaskValidation(this.convertToCurrency(Number(reportLine.landed_cost)), 'Z'),
                //                         this.convertToCurrency(Number(reportLine.selling_price)),
                //                         this.convertToCurrency(Number(reportLine.qty)),
                //                         this.addMaskValidation(this.convertToCurrency(Number(reportLine.unit_cost)), 'Z'),
                //                         this.addMaskValidation(this.convertToCurrency(Number(reportLine.total_cost)), 'Z'),
                //                         this.addMaskValidation(this.convertToCurrency(Number(reportLine.avg_cost)), 'Z'),
                //                         this.addMaskValidation(this.convertToCurrency(Number(reportLine.avg_price)), 'Y'),
                //                         this.addMaskValidation(this.convertToCurrency(Number(reportLine.gross_price)), 'Z'),
                //                         this.convertToCurrency(Number(reportLine.discount))
                //                     );
                                    
                //                     if(this.isShowSalesmanComm){
                //                         detail.push(reportLine.salesman_commission)
                //                     }

                //                     detail.push(reportLine.total_amount)
                                    
                //                     if(this.isShowTotalAmountWithoutTax){
                //                         detail.push(reportLine.total_amount_without_tax)
                //                     }
                //                 } else {
                //                     detail = [
                //                         grouper_name,
                //                         qty,
                //                         this.convertToCurrency(Number(reportLine.total_amount))
                //                     ]
                //                 }

                //                 reportData.push(Object.assign({}, detail))

                //                 if(this.isShowSalesmanComm){
                //                     total_salesman_comm += Number(reportLine.salesman_commission)
                //                     grand_salesman_comm += Number(reportLine.salesman_commission)
                //                 }
                //                 total_amount += Number(reportLine.total_amount)
                //                 grand_total_amount += Number(reportLine.total_amount)

                //                 if(this.isShowTotalAmountWithoutTax){
                //                     total_amount_without_tax += Number(reportLine.total_amount_without_tax)
                //                     grand_total_amount_without_tax += Number(reportLine.total_amount_without_tax)
                //                 }
                //                 total_qty += Number(reportLine.qty)
                //                 total_cost += Number(reportLine.total_cost)
                //                 total_gross_price += Number(reportLine.gross_price)

                //                 grand_qty += Number(reportLine.qty)
                //                 grand_total_cost += Number(reportLine.total_cost)
                //                 grand_gross_price += Number(reportLine.gross_price)
                //                 grand_discount += Number(reportLine.discount);

                //                 if(i == this.birSalesReports.length-1){
                //                     if(this.inputGroupBy != ''){
                //                         let sub_detail = []
                //                         if(this.isShowDetail == true){
                //                             let spacer = grouper_name
                //                             if(this.inputGroupBy == 'supplier_type_id'){
                //                                 spacer = reportLine.header_name
                //                             }

                //                             sub_detail = ["", "", "", "",
                //                                 {content: spacer, styles: {halign: 'right', fontStyle: 'bold'}}, "",
                //                                 this.convertToCurrency(total_qty), '',this.convertToCurrency(total_cost), '', '',this.convertToCurrency(total_gross_price) , this.convertToCurrency(grand_discount)
                //                             ]

                //                             if ((this.inputGroupBy == 'monthly' || this.inputGroupBy == 'supplier_id' || this.inputGroupBy == 'supplier_type_id') && this.isShowDetail == true) {
                //                                 let spacerIndex = sub_detail.findIndex(item => typeof item === 'object' && item.content === spacer);
                //                                 if(this.isShowReferenceCode){
                //                                     sub_detail.splice(spacerIndex + 1, 0,"");
                //                                     sub_detail.splice(spacerIndex - 1, 0,"")
                //                                 } else {
                //                                     sub_detail.splice(spacerIndex + 1, 0, "");
                //                                 }
                //                             }

                //                             if(this.isShowSalesmanComm){
                //                                 sub_detail.push(this.convertToCurrency(total_salesman_comm))
                //                             }

                //                             sub_detail.push(this.convertToCurrency(total_amount))

                //                             if(this.isShowTotalAmountWithoutTax){
                //                                 sub_detail.push(this.convertToCurrency(total_amount_without_tax))
                //                             }

                //                             reportData.push(Object.assign({}, ["rowLine"]))
                //                             reportData.push(Object.assign({}, sub_detail))
                //                         }
                //                     }

                //                     reportData.push(Object.assign({}, ["rowLine"]))

                //                     if(this.isShowDetail == true){
                //                         let detail_arr = ['','', '', '']
                                        
                //                         if(this.isShowReferenceCode){
                //                             detail_arr.push('');
                //                         }

                //                         detail_arr.push('Grand Total :', '','',
                //                             this.convertToCurrency(grand_qty), '',this.convertToCurrency(grand_total_cost), '', '',this.convertToCurrency(grand_gross_price),  this.convertToCurrency(grand_discount) 
                //                         );

                //                         if(this.isShowSalesmanComm){
                //                             detail_arr.push(this.convertToCurrency(grand_salesman_comm))
                //                         }

                //                         detail_arr.push(this.convertToCurrency(grand_total_amount))

                //                         if(this.isShowTotalAmountWithoutTax){
                //                             detail_arr.push(this.convertToCurrency(grand_total_amount_without_tax))
                //                         }
                                        
                //                         reportData.push(Object.assign({}, detail_arr));
                //                     } else {
                //                         reportData.push(Object.assign({}, ['Grand Total :',
                //                             await this.convertDecimal(Number(grand_qty)),
                //                             this.convertToCurrency(grand_total_amount)
                //                         ]));
                //                     }
                //                 } else {
                //                     if(this.isShowDetail == true){
                //                         let current_grouper = ""
                //                         let next_grouper = ""
                //                         if(this.inputGroupBy == 'supplier_type_id'){
                //                             current_grouper = reportLine.header_id
                //                             next_grouper = this.birSalesReports[i+1].header_id
                //                         } else {
                //                             current_grouper = reportLine.grouper_id
                //                             next_grouper = this.birSalesReports[i+1].grouper_id
                //                         }

                //                         if(current_grouper != next_grouper){
                //                             if(this.inputGroupBy != ''){
                //                                 reportData.push(Object.assign({}, ["rowLine"]))
                //                                 let sub_detail = []

                //                                 let spacer = grouper_name
                //                                 if(this.inputGroupBy == 'supplier_type_id'){
                //                                     spacer = reportLine.header_name
                //                                 }

                //                                 if(this.isShowDetail == true){
                //                                     sub_detail = ["", "", "", ""]
                                        
                //                                     if(this.isShowReferenceCode){
                //                                         sub_detail.push('');
                //                                     }

                //                                     sub_detail.push({content: spacer, styles: {halign: 'right', fontStyle: 'bold'}}, "",'',
                //                                         await this.convertDecimal(Number(total_qty)), '',this.convertToCurrency(total_cost), '', '', this.convertToCurrency(total_gross_price),""
                //                                     );

                //                                     if(this.isShowSalesmanComm){
                //                                         sub_detail.push(this.convertToCurrency(total_salesman_comm))
                //                                     }

                //                                     sub_detail.push(this.convertToCurrency(total_amount))

                //                                     if(this.isShowTotalAmountWithoutTax){
                //                                         sub_detail.push(this.convertToCurrency(total_amount_without_tax))
                //                                     }
                //                                 } else {
                //                                     sub_detail = [{content: spacer, styles: {halign: 'right', fontStyle: 'bold'}},
                //                                         await this.convertDecimal(Number(total_qty)),
                //                                         this.convertToCurrency(total_amount)
                //                                     ]
                //                                 }
                //                                 reportData.push(Object.assign({}, sub_detail))

                //                                 total_qty = 0
                //                                 total_amount = 0
                //                                 total_gross_price = 0
                //                             }
                //                         }
                //                     }
                //                 }
                //             }
                //         }

                //         let group_text = ""
                //         if(this.inputGroupBy != ''){
                //             group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                //         }

                //         let design_x = 525
                //         let design_y = 225
                        
                //         if(this.isShowDetail == true){
                //             design_x = 600
                //             design_y = 400
                //         }
                        
                //         doc.setFontSize(14);
                //         doc.setFontType("bold");
                //         doc.text(15,20,"Item Sales Report" + group_text)
                //         doc.setFontType("normal");
                //         doc.setFontSize(10);
                //         if(this.isSeparateSite == true){
                //             doc.text(15, 35, "Site: " + siteSpecific[x].report_details[0].site_name, "left");
                //         } else {
                //             let site_text = ''
                //             if(this.inputSite.length == 0){
                //                 site_text = 'All Sites'
                //             } else {
                //                 let sites = this.inputSite
                //                 for (var s = 0; s < sites.length; s++) {
                //                     if(s == 0){
                //                         site_text += this.siteOptions.find(x => x.id === sites[s]).name
                //                     } else {
                //                         site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                //                     }
                //                 }
                //             }
                //             doc.text(15, 35, "Site/s: " + site_text, "left");
                //         }
                //         doc.text(15,25,"For the Period of " + from_header + " to " + to_header)
                //         let filterText = dissectReportFilters(parameters, this.displayOptions, this.formatOptions)
                //         const {basic, advance} = filterText
                //         let splitTitle;
                //         if (Object.keys(parameters.advanced_filter).length !== 0) {
                //             if (advance.trim().length !== 0) {
                //                 splitTitle = "Filtered by: " + status_header + "," + advance;
                //             } else {
                //                 splitTitle = "Filtered by: " + status_header + filter_header;
                //             }
                //         } else {
                //             splitTitle = "Filtered by: " + status_header + filter_header;
                //         }
                //         splitTitle = doc.splitTextToSize(splitTitle, 250);


                //         doc.text(15,30,splitTitle);

                //         let colStyles = {}
                        
                //         if(this.isShowDetail == true){
                //             if(this.isShowReferenceCode && this.isShowTotalAmountWithoutTax){
                //                 colStyles = {
                //                     0: {cellWidth: 10},
                //                     1: {cellWidth: 25},
                //                     2: {cellWidth: 27},
                //                     3: {cellWidth: 22},
                //                     4: {cellWidth: 27},
                //                     5: {cellWidth: 50},
                //                     6: {cellWidth: 19},
                //                     7: {cellWidth: 22},
                //                     8: {cellWidth: 19},
                //                     9: {cellWidth: 19},
                //                     10: {cellWidth: 22},
                //                     11: {cellWidth: 19},
                //                     12: {cellWidth: 22},
                //                     13: {cellWidth: 22},
                //                     14: {cellWidth: 19},
                //                     15: {cellWidth: 22},
                //                     16: {cellWidth: 22},
                //                 }
                //             } else if (this.isShowReferenceCode){
                //                 colStyles = {
                //                     0: {cellWidth: 10},
                //                     1: {cellWidth: 25},
                //                     2: {cellWidth: 27},
                //                     3: {cellWidth: 22},
                //                     4: {cellWidth: 22},
                //                     5: {cellWidth: 50},
                //                     6: {cellWidth: 19},
                //                     7: {cellWidth: 22},
                //                     8: {cellWidth: 19},
                //                     9: {cellWidth: 19},
                //                     10: {cellWidth: 19},
                //                     11: {cellWidth: 19},
                //                     12: {cellWidth: 22},
                //                     13: {cellWidth: 22},
                //                     14: {cellWidth: 19},
                //                     15: {cellWidth: 22},
                //                 }
                //             } else if (this.isShowTotalAmountWithoutTax){
                //                 colStyles = {
                //                     0: {cellWidth: 10},
                //                     1: {cellWidth: 25},
                //                     2: {cellWidth: 27},
                //                     3: {cellWidth: 22},
                //                     4: {cellWidth: 50},
                //                     5: {cellWidth: 19},
                //                     6: {cellWidth: 22},
                //                     7: {cellWidth: 19},
                //                     8: {cellWidth: 19},
                //                     9: {cellWidth: 19},
                //                     10: {cellWidth: 22},
                //                     11: {cellWidth: 22},
                //                     12: {cellWidth: 22},
                //                     13: {cellWidth: 19},
                //                     14: {cellWidth: 22},
                //                     15: {cellWidth: 22},
                //                 }
                //             } else {
                //                 colStyles = {
                //                     0: {cellWidth: 10},
                //                     1: {cellWidth: 25},
                //                     2: {cellWidth: 27},
                //                     3: {cellWidth: 22},
                //                     4: {cellWidth: 50},
                //                     5: {cellWidth: 19},
                //                     6: {cellWidth: 22},
                //                     7: {cellWidth: 19},
                //                     8: {cellWidth: 19},
                //                     9: {cellWidth: 19},
                //                     10: {cellWidth: 19},
                //                     11: {cellWidth: 19},
                //                     12: {cellWidth: 20},
                //                     13: {cellWidth: 19},
                //                     14: {cellWidth: 22},
                //                     15: {cellWidth: 20},
                //                 }
                //             }
                            
                //         } else {
                //             colStyles = {
                //                 0: {cellWidth: 205},
                //                 1: {cellWidth: 60},
                //                 2: {cellWidth: 60}
                //             }
                //         }

                //         doc.autoTable({
                //             startY: 45,
                //             head: headers,
                //             body: reportData,
                //             theme: 'plain',
                //             tableWidth: 'wrap',
                //             headStyles: {
                //                 lineWidth: 0.15,
                //                 cellPadding: 2,
                //                 rowHeight: 18
                //             },
                //             margin: { bottom: 30 },
                //             styles: {
                //                 cellPadding: 1.0, fontSize: 10,
                //                 halign: 'right',
                //             },
                //             columnStyles: colStyles,
                //             didParseCell: function(data) {
                //                 if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                //                     data.cell.styles.fillColor = [0, 0, 0]
                //                     data.cell.styles.fontSize = 1
                //                     data.cell.styles.cellPadding = 0
                //                 } else if (data.row.section == 'body' && (data.row.raw[0] == 'Grand Total :' || data.row.raw[3] == 'Grand Total :')){
                //                     data.cell.styles.fontStyle = 'bold'
                //                 }
                //             }
                //         });

                //         let printed_by = secureStorage.getItem("email")
                //         if(printed_by == null){
                //             printed_by = ''
                //         }

                //         let pageCount = doc.internal.getNumberOfPages();

                //         for(let i = 1; i <= pageCount; i++) {
                //             doc.setPage(i);
                //             reportUtils.pdfTools.addFooter(doc, printed_by, "Item Sales Report" + group_text, design_x, design_y, i, pageCount)
                //         }
                //     }
                //     doc.save(`Item_Sales_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                // } else {
                //     reportUtils.openNotificationWithIcon(component_x,'warning', 'Try increasing the scope by adjusting the filters.');
                // }
                this.spinning = false;
            },
            getBase64Image(url) {
                const img = new Image();
                img.setAttribute('crossOrigin', 'anonymous');
                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);
                    const dataURL = canvas.toDataURL("image/png");
                }
                return img.src = url
            },
            async generateExcel(){
                const workbook = new ExcelJS.Workbook();
                workbook.created = new Date();
                workbook.modified = new Date();
                const sheet = workbook.addWorksheet("Item Sales Report", {
                    pageSetup:{paperSize: 9}
                });

                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                const data_starts_at_row = 8

                let reportLogo = document.getElementById('reportLogo');
            
                const base64Image = reportUtils.csvxlsxTools.getBase64Image(reportLogo)

                const imageId2 = workbook.addImage({
                    base64: base64Image,
                    extension: 'png',
                });

                sheet.addImage(imageId2, {
                    tl: { col: 0, row: 0 },
                    ext: { width: 61, height: 61 }
                });

                sheet.getRow(4).values = ["Item Sales Report"]
                sheet.getRow(5).values = [`For the Period of ${from_header} to ${to_header}`]
                sheet.getRow(6).values = [`Filtered by: ${status_header}${filter_header}}`]

                //custom header
                let header_arr = []
                header_arr.push("#", "Product Code", "Barcode", "Stock No")

                let row_arr = []
                row_arr.push({ key: "#" , width: 20 },
                    { key: "product_code", width: 15 },
                    { key: "barcode" , width: 20 },
                    { key: "stock_no", width: 15 }
                )

                if(this.isShowReferenceCode){
                    header_arr.push("Reference Code")
                    row_arr.push({ key: "reference_code", width: 20 })
                }

                header_arr.push("Description", "Landed Cost","Selling Price", "Quantity", "Unit Cost", "Total Cost","Average Cost", "Average Price", "Gross Price", "Discount")
                row_arr.push({ key: "desc", width: 30 },
                    { key: "landed_cost", width: 15 },
                    { key: "selling_price", width: 15 },
                    { key: "qty", width: 15 },
                    { key: "unit_cost", width: 15 },
                    { key: "total_cost", width: 15 },
                    { key: "avg_cost", width: 15 },
                    { key: "avg_price", width: 15 },
                    { key: "gross_price", width: 15 },
                    { key: "discount", width: 15 }
                )

                if(this.isShowSalesmanComm){
                    header_arr.push("Salesman Commission")
                    row_arr.push({ key: "salesman_commission", width: 15 })
                }

                header_arr.push("Total Amount")
                row_arr.push({ key: "total_amount", width: 15 })

                if(this.isShowTotalAmountWithoutTax){
                    header_arr.push("Total Amount w/o Vat")
                    row_arr.push({ key: "total_amount_without_tax", width: 15 })
                }

                sheet.getRow(data_starts_at_row).values = header_arr;
                sheet.columns = row_arr;

                var report_details = this.JsonData
                var rowDatas = []
                var horizontal_range = 0
                for(let i = 0; i < report_details.length; i++){
                    const report_detail = report_details[i]
                        if(report_detail){
                            let rowData = {"#": report_detail["#"], desc: report_detail["Name or Description"], barcode: report_detail["Barcode"]}
                            if(this.isShowReferenceCode){
                                Object.assign(rowData, {reference_code: report_detail["Reference Code"]});
                            }

                            let new_obj = {product_code: report_detail["Product Code"], 
                                landed_cost: report_detail["Landed Cost"], 
                                qty: report_detail["Quantity"], 
                                avg_price: report_detail["Average Price"],
                                avg_cost: report_detail["Average Cost"], 
                                selling_price: report_detail["Selling Price"], 
                                stock_no: report_detail["Stock No"], 
                                gross_price: report_detail["Gross Price"],
                                discount: report_detail["Discount"],
                                total_cost: report_detail["Total Cost"],
                                unit_cost: report_detail["Unit Cost"], 
                            }

                            Object.assign(rowData, new_obj);

                            if(this.isShowSalesmanComm){
                                Object.assign(rowData, {salesman_commission: report_detail["Salesman Commission"]});
                            }

                            Object.assign(rowData, {total_amount: report_detail["Total Amount"]});

                            if(this.isShowTotalAmountWithoutTax){
                                Object.assign(rowData, {total_amount_without_tax: report_detail["Total Amount w/o Tax"]});
                            }
                            rowDatas.push(rowData)
                        }
                    }

                sheet.addRows(rowDatas);

                //styles
                sheet.getRow(4).font = { bold: true, size: 16 };
                sheet.getRow(4).height = 20;
                sheet.getRow(data_starts_at_row).font = { bold: true };
                sheet.eachRow(function (Row, rowNum) {
                    if(rowNum >= data_starts_at_row){
                        Row.eachCell(function (Cell, cellNum) {
                            if (rowNum == data_starts_at_row) {
                                Cell.alignment = {
                                    horizontal: 'center'
                                }
                            }
                            else{
                                Cell.alignment = {
                                    vertical: 'middle',
                                    horizontal: 'left'
                                }
                            }
                        })
                    }
                })
                
                workbook.xlsx.writeBuffer().then(function(buffer) {
                    const blob = new Blob([buffer], { type: "applicationi/xlsx" });
                    saveAs(blob, `itemSalesReport.xlsx`);
                });
                this.JsonData = []
            },
            generateFile: async function() {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": from_date,
                    "date_to": to_date,
                    "group": this.inputGroupBy,
                    "isShow": this.isShowDetail,
                    "isShowTotalAmountWithoutTax": this.isShowTotalAmountWithoutTax,
                    "isShowReferenceCode": this.isShowReferenceCode,
                    "isShowSalesmanComm": this.isShowSalesmanComm,
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                    "top": this.inputShowTop,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "advanced_filter": this.params,
                    "isNetReturn": this.isNetReturn
                }

                // check if item returns exist
                if (parameters["isNetReturn"]) {               
                    let check_returns = await HTTPRequest.getRequest(this.endPoint + 'item_returns?', {
                        "site_id": parameters["site_id"],
                            "date_from": parameters["date_from"],
                            "date_to": parameters["date_to"],
                            "isSeparate": true
                    })
                    if (check_returns.length < 1)
                        parameters["isNetReturn"] = false
                }

                // Show a loading popup while the report data is being generated.
                const loadingPopup = this.$message.loading('Generating report...', 0)
                let get_request
                try {
                    get_request = await this.requestWithTimeout(
                        HTTPRequest.getRequest(this.endPoint + 'item_sales?', parameters)
                    )
                } catch (timeoutError) {
                    loadingPopup()
                    this.$notification['error']({
                        message: 'Report Timed Out',
                        description: 'The report is taking too long to generate. Please contact your administrator.'
                    })
                    this.spinning = false;
                    return
                }
                loadingPopup()
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                    this.spinning = false;
                    return
                }
                if(get_request.length > 0){
                    let siteSpecific = get_request;
                    let headers = []
                    if(this.isShowReferenceCode){
                         headers = ["#", "Product Code", "Barcode", "Stock No", "Reference Code", "Name or Description", "Landed Cost", "Selling Price", "Unit Cost","Total Cost", "Average Cost", "Average Price", "Quantity", "Gross Price", "Discount"];
                    }
                    else {
                         headers = ["#", "Product Code", "Barcode", "Stock No", "Name or Description", "Landed Cost", "Selling Price", "Unit Cost", "Total Cost", "Average Cost", "Average Price", "Quantity", "Gross Price", "Discount"];
                    }

                    if(this.isShowSalesmanComm){
                        headers.push("Salesman Commission")
                    }

                    headers.push("Total Amount")

                    if(this.isShowTotalAmountWithoutTax){
                        headers.push("Total Amount w/o Tax")
                    }

                    let site_specific = [];

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details
                        console.log(this.birSalesReports)
                        let reportData = [];
                        if(x > 0){
                            // Add second set of headers
                            reportData.push(headers)
                        }

                        if(this.birSalesReports.length > 0){
                            let total_qty = 0
                            let total_cost = 0
                            let total_amount = 0
                            let total_gross_price = 0
                            let total_amount_without_tax = 0
                            let total_salesman_comm = 0

                            let grand_qty = 0
                            let grand_total_cost = 0
                            let grand_total_amount = 0
                            let grand_gross_price = 0
                            let grand_total_amount_without_tax = 0
                            let grand_salesman_comm = 0

                            let grouper = 'start'
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name

                                if(grouper == 'start'){
                                    let detail_header = [grouper_name];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_id){
                                        let detail_header = [grouper_name];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_id

                                let detail = []
                                detail = [
                                    i+1,
                                    reportLine.product_code,
                                    reportLine.barcode,
                                    String(reportLine.stock_no)];
                                
                                if (this.isShowReferenceCode)
                                    detail.push(reportLine.reference_code)
                                
                                let qty = await this.convertDecimal(Number(reportLine.qty)) 
                                
                                detail.push(reportLine.description,
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.landed_cost,)), 'Z'),
                                    this.addMaskValidation(reportLine.selling_price, 'Y'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.unit_cost,)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.total_cost,)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.avg_cost,)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.avg_price)), 'Y'),
                                    this.convertToCurrency(Number(reportLine.qty)),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.gross_price)), 'Y'),
                                    reportLine.discount
                                );

                                if(this.isShowSalesmanComm){
                                    detail.push(this.convertToCurrency(Number(reportLine.salesman_commission)))
                                }

                                detail.push(this.addMaskValidation(this.convertToCurrency(Number(reportLine.total_amount)), 'Y'));

                                if(this.isShowTotalAmountWithoutTax){
                                    detail.push(this.convertToCurrency(Number(reportLine.total_amount_without_tax)))
                                }
                                
                                total_qty += Number(reportLine.qty)
                                total_cost += Number(reportLine.total_cost)
                                total_amount += Number(reportLine.total_amount)
                                total_salesman_comm += Number(reportLine.salesman_commission)
                                total_amount_without_tax += Number(reportLine.total_amount_without_tax)
                                total_gross_price += Number(reportLine.gross_price)

                                grand_qty += Number(reportLine.qty)
                                grand_total_cost += Number(reportLine.total_cost)
                                grand_total_amount += Number(reportLine.total_amount)
                                grand_salesman_comm += Number(reportLine.salesman_commission)
                                grand_total_amount_without_tax += Number(reportLine.total_amount_without_tax)
                                grand_gross_price += Number(reportLine.gross_price)

                                reportData.push(Object.assign({}, detail))

                                let sub_detail = []
                                let grand_detail = []
                                if(i == this.birSalesReports.length-1){
                                    //Subtotal
                                    sub_detail = ['','','','']
                                    grand_detail = ['','','','']

                                    if(this.isShowReferenceCode){
                                        sub_detail.push('')
                                        grand_detail.push('')
                                    }

                                    
                                    sub_detail.push('Sub Total :', '', '','',this.addMaskValidation(this.convertToCurrency(total_cost), 'Z'),
                                        '', '', await this.convertDecimal(Number(total_qty)),
                                        this.addMaskValidation(this.convertToCurrency(total_gross_price), 'Y'),
                                        ""
                                    );

                                    if(this.isShowSalesmanComm){
                                        sub_detail.push(this.convertToCurrency(total_salesman_comm))
                                    }

                                    sub_detail.push(this.addMaskValidation(this.convertToCurrency(total_amount), 'Y'))

                                    if(this.isShowTotalAmountWithoutTax){
                                        sub_detail.push(this.addMaskValidation(this.convertToCurrency(total_amount_without_tax), 'Y'))
                                    }

                                    reportData.push(Object.assign({}, sub_detail))

                                    //Grand Total
                                    grand_detail.push('Grand Total :', '', '','',this.addMaskValidation(this.convertToCurrency(grand_total_cost), 'Z'),
                                            '', '',await this.convertDecimal(Number(grand_qty)),
                                            this.addMaskValidation(this.convertToCurrency(grand_gross_price), 'Y'),
                                            ""
                                    );

                                    if(this.isShowSalesmanComm){
                                        grand_detail.push(this.convertToCurrency(grand_salesman_comm))
                                    }

                                    grand_detail.push(this.addMaskValidation(this.convertToCurrency(grand_total_amount), 'Y'))

                                    if(this.isShowTotalAmountWithoutTax){
                                        grand_detail.push(this.addMaskValidation(this.convertToCurrency(grand_total_amount_without_tax), 'Y'))
                                    }

                                    reportData.push(Object.assign({}, grand_detail));
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.grouper_id
                                    next_grouper = this.birSalesReports[i+1].grouper_id

                                    if(current_grouper != next_grouper){
                                        //Subtotal
                                        sub_detail = ['','','','']
                                        if(this.isShowReferenceCode)
                                        sub_detail.push('')
                                
                                        sub_detail.push('Sub Total :', '', '','',this.addMaskValidation(this.convertToCurrency(total_cost), 'Z'),
                                            '', '', this.convertToCurrency(total_qty),
                                            this.addMaskValidation(this.convertToCurrency(total_gross_price), 'Y'),
                                            ""
                                        );

                                        if(this.isShowSalesmanComm){
                                            sub_detail.push(this.convertToCurrency(total_salesman_comm))
                                        }

                                        sub_detail.push(this.addMaskValidation(this.convertToCurrency(total_amount), 'Y'))

                                        if(this.isShowTotalAmountWithoutTax){
                                            sub_detail.push(this.addMaskValidation(this.convertToCurrency(total_amount_without_tax), 'Y'))
                                        }

                                        reportData.push(Object.assign({}, sub_detail))

                                        total_qty = 0
                                        total_amount = 0
                                        total_salesman_comm = 0
                                        total_gross_price = 0
                                        total_cost = 0
                                    }
                                }
                            }

                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.sortOptions[0].value
                        }

                        if(this.isSeparateSite == true){
                            reportData.unshift([siteSpecific[x].report_details[0].site_name]);
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            reportData.unshift([site_text]);
                        }
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push(["Item Sales Report" + group_text, "Generated By: " + printed_by,"For the Period of " + from_header + " to " + to_header])
                        reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                            var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                [val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning = false;
            },
            clearJsonData(){
             this.JsonData = [];
            },
            // Background Excel/CSV generation for ranges greater than one calendar
            // month. Mirrors generateReportBg (PDF background) but targets the
            // Excel/CSV export worker via export_format, and passes the resolved
            // cost/price masking flags so server output matches the user's rights.
            generateFileBackground: async function (format) {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let {filter_header, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)

                // group_text mirrors generateFile exactly (it uses sortOptions[0]).
                let group_text = ""
                if(this.inputGroupBy != ''){
                    group_text = " by " + this.sortOptions[0].value
                }

                // Combined site text for "Separate per site = OFF", mirroring generateFile.
                let site_text = ''
                if(this.inputSite.length == 0){
                    site_text = 'All Sites'
                } else {
                    let sites = this.inputSite
                    for (var s = 0; s < sites.length; s++) {
                        let opt = this.siteOptions.find(x => x.id === sites[s])
                        let name = opt ? opt.name : ''
                        site_text += (s == 0 ? name : ', ' + name)
                    }
                }

                let printed_by = secureStorage.getItem("email") || ''

                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": from_date,
                    "date_to": to_date,
                    "group": this.inputGroupBy,
                    "isShow": this.isShowDetail,
                    "isShowReferenceCode": this.isShowReferenceCode,
                    "isShowSalesmanComm": this.isShowSalesmanComm,
                    "isShowTotalAmountWithoutTax": this.isShowTotalAmountWithoutTax,
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                    "top": this.inputShowTop,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "advanced_filter": this.params,
                    "isNetReturn": this.isNetReturn,
                    "export_format": format,
                    // Resolved masking flags (mirror addMaskValidation): mask when
                    // the user lacks the corresponding cost/price right.
                    "mask_cost": !this.accessCostPriceRights.includes('Z'),
                    "mask_price": !this.accessCostPriceRights.includes('Y'),
                    // Display strings so the background file matches the UI byte-for-byte.
                    "from_header": from_header,
                    "to_header": to_header,
                    "group_text": group_text,
                    "site_text": site_text,
                    "printed_by": printed_by,
                    "status_header": status_header,
                    "filter_header": filter_header
                }

                // check if item returns exist
                if (parameters["isNetReturn"]) {
                    let check_returns = await HTTPRequest.getRequestReport(this.endPoint + 'item_returns?', {
                        "site_id": parameters["site_id"],
                        "date_from": parameters["date_from"],
                        "date_to": parameters["date_to"],
                        "isSeparate": true
                    })
                    if (check_returns.length < 1)
                        parameters["isNetReturn"] = false
                }

                var get_request = await HTTPRequest.getRequestReport(this.endPoint + 'item_sales_background?', parameters);
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                    this.spinning = false;
                    return
                } else {
                    this.$notification['success']({
                        message: 'Report Generating',
                        description: "Report running in background. Check jobs page to monitor report generation.",
                        style:{
                            color: 'rgba(0, 0, 0, 0.65)',
                            border: '1px solid #b7eb8f',
                            backgroundColor: '#f6ffed'
                        }
                    });
                }
                this.spinning = false;
            },
            // Clears any previously generated report data when filters change.
            resetGeneratedReport(){
                if (this.JsonData.length > 0) {
                    this.JsonData = [];
                }
            },
            // After the CSV is generated by vue-json-to-csv (which reads the
            // current JsonData synchronously on click), reset JsonData so the
            // "Generate Report" button reappears and the report can be
            // regenerated with new filters.
            onCsvDownloaded(){
                this.$nextTick(() => { this.JsonData = []; });
            },
            // Races a request promise against a timeout. Rejects with a timeout
            // marker if the request does not resolve within reportTimeoutMs so the
            // caller can show a "contact administrator" message.
            requestWithTimeout(requestPromise){
                let timer
                const timeout = new Promise((resolve, reject) => {
                    timer = setTimeout(() => reject(new Error('REQUEST_TIMEOUT')), this.reportTimeoutMs)
                })
                return Promise.race([requestPromise, timeout]).finally(() => clearTimeout(timer))
            },
            addMaskValidation(value, rights){
                if((!this.accessCostPriceRights.includes('Z') && rights == 'Z') || (!this.accessCostPriceRights.includes('Y') && rights == 'Y')){
                    return '***';
                }else{
                    return value
                }
            }
        }
    };
</script>

<style></style>